import AppState from "../AppState";

export const selectAdapterInfo = (state: AppState) => {
  return state.adapterConfig && state.adapterConfig.AdapterInfo;
};

export const selectIsAnalyticsEnabled = (state: AppState) => {
  return true;
};

export const selectAdapterId = (state: AppState): string | undefined => {
  return state.adapterConfig?.AdapterInfo?.adapterId;
};

/**
 * SM4A-3207 — the sequential category-load path is scoped to HCL, whose backend
 * degrades under overlapping catalog requests. Other platforms keep the
 * previous concurrent behaviour.
 */
export const selectIsHclPlatform = (state: AppState): boolean => {
  return state.adapterConfig?.AdapterInfo?.adapterId === "hcl";
};

export const selectIsCategoryProductsV2Available = (
  state: AppState,
): boolean => {
  return (
    state.adapterConfig?.AdapterInfo?.operations?.includes(
      "GET /v2/{accountId}/categories/{categoryId}/products",
    ) || false
  );
};
